import React from "react";
import {localField} from "../../../../_ae/helpers/UIHelper";
import {fetchBrandsForSelect, useBrandsForSelect} from "../../../../redux/brands";
import {AEAutocompleteField} from "../../../../_metronic/_partials/controls/forms/AEField";
import {useDispatch} from "react-redux";

export const Field = ({...props}) => {
  const dispatch = useDispatch();
  const {data, isLoading, metadata} = useBrandsForSelect()

  const handleSearch = search => {
    dispatch(
      fetchBrandsForSelect({
        ...metadata,
        filters: {
          ...metadata.filters,
          search
        }
      })
    )
  }

  return (
    <AEAutocompleteField
      name="brand"
      label={'BRAND'}
      options={data}
      getOptionLabel={option=>option[localField()]}
      onOpen={()=>{
        handleSearch('')
      }}
      onInputChange={(event, search) => {
        handleSearch(search)
      }}
      loading={isLoading}
      {...props}
    />
  )
}